import { create } from 'zustand';

interface DemoStoreStore {
  demoStoreId: number;
  setDemoStoreId: (storeId: number) => void;
}

export const useDemoStoreStore = create<DemoStoreStore>((set) => ({
  demoStoreId: 0,
  setDemoStoreId: (storeId: number) => set({ demoStoreId: storeId }),
}));
